const articles = {
  fr: {
    featuredPost: {
      id: 1,

      title:
        "Partenariat officiel entre notre association et le Club Atlas Oulmes de Badminton",

      excerpt:
        "Notre association est fière d’annoncer la signature d’un partenariat stratégique avec le Club Atlas Oulmes de Badminton afin de soutenir le sport, la jeunesse et les valeurs d’excellence.",

      content: `
🏅 Le sport est un pilier fondamental du développement des jeunes et du renforcement du lien social.

C’est dans cet esprit que notre association a officialisé un partenariat avec le Club Atlas Oulmes de Badminton.

🤝 Une vision commune

Ce partenariat repose sur des valeurs partagées :

🎯 discipline
🤍 respect
👥 esprit d’équipe
🔥 engagement
💪 persévérance

🏸 Le Club Atlas Oulmes de Badminton

Le club œuvre activement pour :

🌱 former les jeunes talents
🏆 promouvoir le badminton
🏘️ renforcer l’esprit sportif local
✨ transmettre des valeurs positives à la jeunesse

🎯 Objectifs du partenariat

🏟️ soutenir les activités sportives
🧒 encourager la jeunesse locale
🤗 valoriser le sport comme outil d’inclusion
🌍 créer un impact communautaire durable

🚀 Une collaboration tournée vers l’avenir

Des actions communes seront mises en place :

📅 événements sportifs
🎓 accompagnement des jeunes
🤲 initiatives communautaires

🌟 Ce partenariat marque le début d’une collaboration durable au service du sport et des jeunes.
`,

      author: "Service Communication",
      date: "Février 2025",
      readTime: "6 minutes",
      category: "Partenariat Sportif",

      tags: ["Partenariat", "Sport", "Badminton", "Jeunesse", "Oulmes"],

      likes: 0,
      comments: 0,

      image: "/images/b1.jpg",

      gallery: ["/images/b2.jpg", "/images/b3.jpg"],
    },

    posts: [
      {
        id: 2,

        title:
          "La création du site web officiel de l’association : un pas vers le digital",

        excerpt:
          "L’association franchit une étape majeure avec la création de son site web officiel, une plateforme moderne dédiée à la communication, à l’engagement des membres et au rayonnement de ses actions.",

        content: `
🌍 Dans un monde de plus en plus digitalisé, disposer d’un site web n’est plus un luxe, mais une nécessité.

C’est dans cette optique que notre association a lancé la création de son site web officiel, un projet stratégique visant à renforcer la communication et à faciliter l’accès à l’information.

❓ Pourquoi créer un site web pour l’association ?

Avant la création du site, la communication se faisait principalement via les réseaux sociaux et le contact direct.

Cependant, plusieurs besoins sont rapidement apparus :

📌 centraliser les informations officielles,
🎯 présenter clairement la mission et les valeurs de l’association,
🤝 faciliter l’adhésion des nouveaux membres,
🌟 valoriser les activités, projets et partenariats,
🔐 offrir un espace dédié aux membres et aux administrateurs.

Le site web est devenu la solution idéale pour répondre à ces objectifs.

👥 Une plateforme pensée pour tous

Le site a été conçu pour être :

✅ simple à utiliser, même pour les personnes peu à l’aise avec le digital.
📱 accessible sur téléphone, tablette et ordinateur.
🧭 clair et structuré, avec une navigation intuitive.
⚡ rapide et sécurisé, pour protéger les données des membres.

Chaque page a été pensée pour offrir une expérience fluide et professionnelle.

🛠️ Des fonctionnalités utiles et modernes

Le site de l’association ne se limite pas à une simple vitrine.

Il intègre plusieurs fonctionnalités importantes :

📝 formulaire d’adhésion en ligne.
🔑 espace membre sécurisé.
📊 gestion des présences et des activités.
📰 publication d’articles et d’actualités.
🤝 mise en avant des partenaires et des projets.

Ces outils facilitent le travail interne et améliorent la communication externe.

🚀 Un outil au service du développement

Grâce au site web, l’association gagne en visibilité et en crédibilité.

Les partenaires, les bénévoles et le public peuvent désormais :

👀 comprendre rapidement les actions de l’association.
📅 suivre les événements et les projets en cours.
📩 entrer en contact plus facilement.
👆 rejoindre la communauté en quelques clics.

Le digital devient ainsi un levier de croissance et d’impact.

🔮 Une vision tournée vers l’avenir

La création du site web marque le début d’une nouvelle étape.

À l’avenir, la plateforme continuera d’évoluer avec :

✨ de nouvelles fonctionnalités.
🎮 plus de contenus interactifs.
🙌 une meilleure implication des membres.
🌐 et une présence digitale encore plus forte.

Ce projet démontre que l’association avance avec son temps et place l’innovation au cœur de son développement.
`,

        author: "Équipe Digitale de l’Association",
        date: "Janvier 2026",
        readTime: "8 minutes",
        category: "Transformation Digitale",

        tags: ["Site Web", "Digital", "Association", "Innovation"],

        likes: 36,
        comments: 12,

        image: "./images/siteweb.jpeg",

        gallery: ["./images/siteweb1.jpeg", "./images/siteweb2.jpeg"],
      },

      {
        id: 3,

        title: "Jeunesse et formation : bâtir les compétences de demain",

        excerpt:
          "La formation des jeunes est au cœur du développement durable. À travers ses actions, l’association s’engage à accompagner la jeunesse et à renforcer ses compétences pour préparer un avenir meilleur.",

        content: `
🎓 La jeunesse et la formation, clés de l’avenir

La jeunesse représente une richesse inestimable pour toute société.

Investir dans la formation des jeunes, c’est leur offrir les outils nécessaires pour construire leur avenir et contribuer activement au développement de leur communauté.

📚 Apprendre pour mieux agir

À travers des actions de formation et d’accompagnement, notre association s’engage à renforcer les compétences des jeunes, aussi bien sur le plan éducatif que personnel.

Ces initiatives visent à développer l’autonomie, la confiance en soi et l’esprit de responsabilité.

👥 Un accompagnement humain et inclusif

La formation ne se limite pas à l’acquisition de connaissances.

Elle repose également sur l’écoute, l’échange et le partage d’expériences.

En créant un environnement bienveillant, l’association encourage chaque jeune à révéler son potentiel.

🚀 Préparer les leaders de demain

En soutenant la jeunesse aujourd’hui, nous préparons une génération capable de relever les défis de demain.

Grâce à la formation, les jeunes deviennent des acteurs engagés, prêts à participer activement à la vie sociale, culturelle et professionnelle.

✨ La formation des jeunes est un investissement durable pour un avenir meilleur.
`,

        author: "Équipe Formation & Jeunesse",
        date: "Octobre 2025",
        readTime: "6 minutes",
        category: "Jeunesse & Formation",

        tags: ["Jeunesse", "Formation", "Éducation", "Avenir"],

        likes: 24,
        comments: 7,

        image: "/images/blog.jpg",

        gallery: ["/images/blog1.jpg", "/images/blog2.jpg"],
      },

      {
        id: 4,

        title:
          "Un partenariat institutionnel au service de la jeunesse et de l’innovation",

        excerpt:
          "Le partenariat avec le Ministère de la Jeunesse, de la Culture et de la Communication – Département de la Jeunesse marque une étape importante dans le renforcement des actions de l’association en faveur des jeunes et de l’innovation.",

        content: `
🤝 Un partenariat porteur de sens

Dans le cadre de son engagement en faveur de la jeunesse, notre association a eu l’honneur de bénéficier du soutien du Ministère de la Jeunesse, de la Culture et de la Communication – Département de la Jeunesse.

Ce partenariat institutionnel constitue un levier essentiel pour renforcer l’impact de nos actions et accompagner les jeunes dans leur développement personnel et professionnel.

🎯 Des objectifs communs

Ce partenariat repose sur une vision partagée visant à :

📌 encourager l’innovation et la créativité chez les jeunes,
🎓 soutenir les initiatives de formation et d’accompagnement,
🚀 favoriser l’entrepreneuriat et l’engagement citoyen,
🤝 créer des opportunités d’échange et de collaboration,
🌍 contribuer au développement durable et inclusif.

L’alignement des valeurs entre l’association et le Ministère permet de construire des projets à fort impact social.

🏗️ Des actions concrètes sur le terrain

Grâce à ce partenariat, plusieurs actions peuvent être mises en œuvre :

🧪 développement de laboratoires d’innovation,
📚 organisation d’ateliers et de formations,
👥 accompagnement des jeunes porteurs de projets,
📢 sensibilisation et promotion des initiatives citoyennes,
🤲 soutien aux associations et aux acteurs locaux.

Ces actions visent à offrir aux jeunes un cadre propice à l’apprentissage et à l’épanouissement.

🌱 Un impact durable pour la jeunesse

Le soutien institutionnel du Ministère renforce la crédibilité et la visibilité de l’association.

Il permet également d’assurer la continuité et la qualité des projets, tout en touchant un public plus large.

👀 Les jeunes bénéficient ainsi :

✔️ d’un meilleur accès aux ressources,
✔️ d’un accompagnement structuré,
✔️ d’opportunités de formation et d’innovation,
✔️ d’un environnement stimulant et inclusif.

🔮 Une collaboration tournée vers l’avenir

Ce partenariat s’inscrit dans une dynamique à long terme.

L’association ambitionne de développer davantage de projets innovants, d’élargir son réseau de partenaires et de renforcer l’implication des jeunes dans la vie sociale et citoyenne.

Ce soutien institutionnel confirme la volonté commune de placer la jeunesse au cœur du développement et de bâtir ensemble un avenir prometteur.
`,

        author: "Équipe Partenariats & Développement",
        date: "Novembre 2025",
        readTime: "7 minutes",
        category: "Partenariats Institutionnels",

        tags: ["Partenariat", "Jeunesse", "Innovation", "Institutionnel"],

        likes: 0,
        comments: 0,

        image: "/images/minis.jpeg",
      },

      {
        id: 5,

        title:
          "Participation de l’Association ALEOA au Salon International de l’Édition et du Livre 2026",

        excerpt:
          "L’Association des Leaders de l’Excellence a participé au Salon International de l’Édition et du Livre 2026 à travers une visite culturelle et formative permettant aux membres de découvrir plusieurs espaces éducatifs, institutionnels et culturels.",

        content: `
📚 Une expérience culturelle et éducative enrichissante

Dans le cadre de son ouverture continue sur les espaces culturels et institutionnels, l’Association des Leaders de l’Excellence (ALEOA) a organisé, le jeudi 7 mai 2026, une visite culturelle et formative au Salon International de l’Édition et du Livre.

Cette sortie a permis aux membres de vivre une expérience enrichissante alliant découverte, échange et apprentissage dans une ambiance dynamique marquée par la curiosité et l’esprit de partage.

🌍 Découverte des espaces culturels

Les participants ont eu l’opportunité de visiter différents stands et espaces culturels proposant une grande diversité d’ouvrages littéraires, éducatifs et intellectuels.

Cette visite a également permis de découvrir plusieurs initiatives nationales encourageant :

📖 la lecture,
🎓 l’apprentissage,
🌱 le développement personnel,
🤝 l’engagement des jeunes dans la vie culturelle et éducative.

Cette expérience a renforcé l’esprit de communication et de collaboration entre les membres de l’association.

🏛️ Visite du stand du Parlement

Parmi les moments forts de cette visite figurait le passage au stand du Parlement marocain.

Les membres de l’association ont participé à une séance interactive présentant :

✔️ les missions du Parlement,
✔️ le rôle de l’institution législative,
✔️ le fonctionnement des commissions parlementaires,
✔️ les mécanismes de débat et de vote des lois.

Les échanges ont suscité un grand intérêt auprès des participants et ont permis de rapprocher davantage les jeunes des notions de citoyenneté active et de participation institutionnelle.

🎁 Certains membres ont également reçu des cadeaux souvenirs offerts par l’institution parlementaire en reconnaissance de leur participation et de leur interaction durant cette activité.

📖 Participation au Projet National de la Lecture

L’association s’est également distinguée au sein du stand du Projet National de la Lecture.

Les encadrants et les membres ont participé à plusieurs activités culturelles et interactives mettant en avant :

📚 l’importance de la lecture,
🎨 la créativité,
🤝 le travail collectif,
💡 l’esprit d’initiative.

Cette participation reflète les valeurs de l’association basées sur le savoir, l’engagement et le développement des compétences des jeunes.

🚀 Une vision tournée vers l’avenir

À travers cette participation, l’Association des Leaders de l’Excellence réaffirme sa volonté d’offrir à ses membres des expériences enrichissantes mêlant culture, formation et découverte.

Ces initiatives contribuent au développement d’une jeunesse consciente, ouverte sur le savoir et convaincue du rôle essentiel de la culture dans le développement personnel et le changement positif.
`,

        author: "Équipe Communication ALEOA",
        date: "Mai 2026",
        readTime: "6 minutes",
        category: "Activités Culturelles",

        tags: [
          "Salon du Livre",
          "Culture",
          "Jeunesse",
          "Lecture",
          "Citoyenneté",
        ],

        likes: 0,
        comments: 0,

        image: "/images/evnt4.jpeg",

        gallery: ["/images/p13.jpeg", "/images/p16.jpeg"],
      },
    ],
  },

  // PART 2: ARABIC
  ar: {
    featuredPost: {
      id: 1,

      title: "شراكة رسمية بين جمعيتنا ونادي أطلس أولماس للبادمينتون",

      excerpt:
        "تفخر جمعيتنا بالإعلان عن توقيع شراكة استراتيجية مع نادي أطلس أولماس للبادمينتون من أجل دعم الرياضة والشباب وقيم التميز.",

      content: `
🏅 تُعد الرياضة ركيزة أساسية لتنمية الشباب وتعزيز الروابط الاجتماعية.

ومن هذا المنطلق، قامت جمعيتنا بإضفاء الطابع الرسمي على شراكة مع نادي أطلس أولماس للبادمينتون.

🤝 رؤية مشتركة

تقوم هذه الشراكة على مجموعة من القيم المشتركة:

🎯 الانضباط
🤍 الاحترام
👥 روح الفريق
🔥 الالتزام
💪 المثابرة

🏸 نادي أطلس أولماس للبادمينتون

يعمل النادي بشكل فعال على:

🌱 تكوين المواهب الشابة
🏆 النهوض برياضة البادمينتون
🏘️ تعزيز الروح الرياضية محلياً
✨ ترسيخ القيم الإيجابية لدى الشباب

🎯 أهداف الشراكة

🏟️ دعم الأنشطة الرياضية
🧒 تشجيع الشباب المحلي
🤗 جعل الرياضة وسيلة للإدماج
🌍 إحداث أثر مجتمعي مستدام

🚀 تعاون يتطلع إلى المستقبل

سيتم تنفيذ مجموعة من الأنشطة المشتركة:

📅 فعاليات رياضية
🎓 مواكبة الشباب
🤲 مبادرات مجتمعية

🌟 تمثل هذه الشراكة بداية تعاون مستدام في خدمة الرياضة والشباب.
`,

      author: "مصلحة التواصل",
      date: "فبراير 2025",
      readTime: "6 دقائق",
      category: "شراكة رياضية",

      tags: ["شراكة", "رياضة", "بادمينتون", "شباب", "أولماس"],

      likes: 0,
      comments: 0,

      image: "/images/b1.jpg",

      gallery: ["/images/b2.jpg", "/images/b3.jpg"],
    },

    posts: [
      {
        id: 2,

        title: "إنشاء الموقع الإلكتروني الرسمي للجمعية: خطوة نحو التحول الرقمي",

        excerpt:
          "تخطو الجمعية خطوة مهمة من خلال إنشاء موقعها الإلكتروني الرسمي، وهي منصة حديثة مخصصة للتواصل وإشراك الأعضاء وإبراز أنشطتها ومبادراتها.",

        content: `
🌍 في عالم يتجه بشكل متزايد نحو الرقمنة، لم يعد امتلاك موقع إلكتروني أمراً ثانوياً، بل أصبح ضرورة.

ومن هذا المنطلق، أطلقت جمعيتنا مشروع إنشاء موقعها الإلكتروني الرسمي، باعتباره مشروعاً استراتيجياً يهدف إلى تعزيز التواصل وتسهيل الوصول إلى المعلومات.

❓ لماذا إنشاء موقع إلكتروني للجمعية؟

قبل إنشاء الموقع، كان التواصل يتم أساساً عبر شبكات التواصل الاجتماعي والتواصل المباشر.

لكن ظهرت بسرعة عدة حاجيات:

📌 تجميع المعلومات الرسمية في مكان واحد،
🎯 تقديم مهمة الجمعية وقيمها بشكل واضح،
🤝 تسهيل انضمام الأعضاء الجدد،
🌟 إبراز الأنشطة والمشاريع والشراكات،
🔐 توفير فضاء مخصص للأعضاء والمسؤولين.

أصبح الموقع الإلكتروني الحل الأنسب للاستجابة لهذه الأهداف.

👥 منصة موجهة للجميع

تم تصميم الموقع ليكون:

✅ سهل الاستخدام، حتى بالنسبة للأشخاص الأقل خبرة في المجال الرقمي.
📱 متاحاً على الهاتف واللوحي والحاسوب.
🧭 واضحاً ومنظماً مع تنقل سهل وبديهي.
⚡ سريعاً وآمناً لحماية بيانات الأعضاء.

وقد تم تصميم كل صفحة لتوفير تجربة سلسة واحترافية.

🛠️ وظائف مفيدة وحديثة

لا يقتصر موقع الجمعية على كونه واجهة تعريفية فقط.

بل يتضمن مجموعة من الوظائف المهمة:

📝 استمارة الانضمام عبر الإنترنت.
🔑 فضاء آمن للأعضاء.
📊 تدبير الحضور والأنشطة.
📰 نشر المقالات والأخبار.
🤝 إبراز الشركاء والمشاريع.

تسهل هذه الأدوات العمل الداخلي وتحسن التواصل الخارجي.

🚀 أداة في خدمة التطور

بفضل الموقع الإلكتروني، تعزز الجمعية حضورها ومصداقيتها.

وأصبح بإمكان الشركاء والمتطوعين والجمهور:

👀 فهم أنشطة الجمعية بسرعة.
📅 متابعة الفعاليات والمشاريع الجارية.
📩 التواصل بسهولة أكبر.
👆 الانضمام إلى المجتمع ببضع نقرات.

وهكذا أصبحت الرقمنة رافعة للنمو والأثر.

🔮 رؤية متجهة نحو المستقبل

يمثل إنشاء الموقع الإلكتروني بداية مرحلة جديدة.

وستواصل المنصة تطورها مستقبلاً من خلال:

✨ وظائف جديدة.
🎮 مزيد من المحتويات التفاعلية.
🙌 إشراك أفضل للأعضاء.
🌐 وحضور رقمي أقوى.

ويبرهن هذا المشروع على أن الجمعية تواكب العصر وتضع الابتكار في صميم تطورها.
`,

        author: "الفريق الرقمي للجمعية",
        date: "يناير 2026",
        readTime: "8 دقائق",
        category: "التحول الرقمي",

        tags: ["موقع إلكتروني", "رقمنة", "جمعية", "ابتكار"],

        likes: 36,
        comments: 12,

        image: "./images/siteweb.jpeg",

        gallery: ["./images/siteweb1.jpeg", "./images/siteweb2.jpeg"],
      },

      {
        id: 3,

        title: "الشباب والتكوين: بناء مهارات الغد",

        excerpt:
          "يشكل تكوين الشباب محوراً أساسياً للتنمية المستدامة. ومن خلال أنشطتها، تلتزم الجمعية بمواكبة الشباب وتعزيز مهاراتهم من أجل إعداد مستقبل أفضل.",

        content: `
🎓 الشباب والتكوين، مفتاح المستقبل

يمثل الشباب ثروة لا تقدر بثمن لأي مجتمع.

فالاستثمار في تكوين الشباب يعني توفير الأدوات اللازمة لهم لبناء مستقبلهم والمساهمة بشكل فعال في تنمية مجتمعهم.

📚 التعلم من أجل العمل بشكل أفضل

من خلال أنشطة التكوين والمواكبة، تلتزم جمعيتنا بتعزيز مهارات الشباب، سواء على المستوى التعليمي أو الشخصي.

وتهدف هذه المبادرات إلى تنمية الاستقلالية والثقة بالنفس وروح المسؤولية.

👥 مواكبة إنسانية وشاملة

لا يقتصر التكوين على اكتساب المعارف.

بل يعتمد أيضاً على الاستماع والتبادل وتقاسم التجارب.

ومن خلال خلق بيئة داعمة، تشجع الجمعية كل شاب على اكتشاف إمكاناته.

🚀 إعداد قادة الغد

من خلال دعم الشباب اليوم، نساهم في إعداد جيل قادر على مواجهة تحديات الغد.

وبفضل التكوين، يصبح الشباب فاعلين ملتزمين ومستعدين للمشاركة بشكل فعال في الحياة الاجتماعية والثقافية والمهنية.

✨ إن تكوين الشباب استثمار مستدام من أجل مستقبل أفضل.
`,

        author: "فريق التكوين والشباب",
        date: "أكتوبر 2025",
        readTime: "6 دقائق",
        category: "الشباب والتكوين",

        tags: ["الشباب", "التكوين", "التعليم", "المستقبل"],

        likes: 24,
        comments: 7,

        image: "/images/blog.jpg",

        gallery: ["/images/blog1.jpg", "/images/blog2.jpg"],
      },

      {
        id: 4,

        title: "شراكة مؤسساتية في خدمة الشباب والابتكار",

        excerpt:
          "تمثل الشراكة مع وزارة الشباب والثقافة والتواصل – قطاع الشباب مرحلة مهمة في تعزيز أنشطة الجمعية لفائدة الشباب والابتكار.",

        content: `
🤝 شراكة هادفة

في إطار التزامها بقضايا الشباب، تشرفت جمعيتنا بالاستفادة من دعم وزارة الشباب والثقافة والتواصل – قطاع الشباب.

وتشكل هذه الشراكة المؤسساتية رافعة أساسية لتعزيز أثر أنشطتنا ومواكبة الشباب في تطورهم الشخصي والمهني.

🎯 أهداف مشتركة

تقوم هذه الشراكة على رؤية مشتركة تهدف إلى:

📌 تشجيع الابتكار والإبداع لدى الشباب،
🎓 دعم مبادرات التكوين والمواكبة،
🚀 تشجيع ريادة الأعمال والمشاركة المواطنة،
🤝 خلق فرص للتبادل والتعاون،
🌍 المساهمة في التنمية المستدامة والشاملة.

ويسمح انسجام القيم بين الجمعية والوزارة ببناء مشاريع ذات أثر اجتماعي قوي.

🏗️ أنشطة ملموسة على أرض الواقع

بفضل هذه الشراكة، يمكن تنفيذ مجموعة من الأنشطة:

🧪 تطوير مختبرات للابتكار،
📚 تنظيم ورشات وتكوينات،
👥 مواكبة الشباب حاملي المشاريع،
📢 التحسيس بالمبادرات المواطنة والتعريف بها،
🤲 دعم الجمعيات والفاعلين المحليين.

وتهدف هذه الأنشطة إلى توفير بيئة ملائمة للشباب للتعلم والتطور.

🌱 أثر مستدام لفائدة الشباب

يعزز الدعم المؤسساتي للوزارة مصداقية الجمعية وحضورها.

كما يساهم في ضمان استمرارية وجودة المشاريع، مع الوصول إلى جمهور أوسع.

👀 ويستفيد الشباب بذلك من:

✔️ وصول أفضل إلى الموارد،
✔️ مواكبة منظمة،
✔️ فرص للتكوين والابتكار،
✔️ بيئة محفزة وشاملة.

🔮 تعاون يتطلع إلى المستقبل

تندرج هذه الشراكة ضمن دينامية طويلة الأمد.

وتطمح الجمعية إلى تطوير المزيد من المشاريع المبتكرة، وتوسيع شبكة شركائها، وتعزيز انخراط الشباب في الحياة الاجتماعية والمواطنة.

ويؤكد هذا الدعم المؤسساتي الإرادة المشتركة لجعل الشباب في صميم التنمية وبناء مستقبل واعد معاً.
`,

        author: "فريق الشراكات والتنمية",
        date: "نونبر 2025",
        readTime: "7 دقائق",
        category: "الشراكات المؤسساتية",

        tags: ["شراكة", "شباب", "ابتكار", "مؤسساتي"],

        likes: 0,
        comments: 0,

        image: "/images/minis.jpeg",
      },

      {
        id: 5,

        title:
          "مشاركة جمعية قادة التميز ALEOA في المعرض الدولي للنشر والكتاب 2026",

        excerpt:
          "شاركت جمعية قادة التميز في المعرض الدولي للنشر والكتاب 2026 من خلال زيارة ثقافية وتكوينية أتاحت للأعضاء اكتشاف مجموعة من الفضاءات التعليمية والمؤسساتية والثقافية.",

        content: `
📚 تجربة ثقافية وتربوية غنية

في إطار انفتاحها المستمر على الفضاءات الثقافية والمؤسساتية، نظمت جمعية قادة التميز (ALEOA) يوم الخميس 7 ماي 2026 زيارة ثقافية وتكوينية إلى المعرض الدولي للنشر والكتاب.

وقد أتاحت هذه الزيارة للأعضاء خوض تجربة غنية تجمع بين الاكتشاف والتبادل والتعلم، في أجواء ديناميكية اتسمت بالفضول وروح المشاركة.

🌍 اكتشاف الفضاءات الثقافية

أتيح للمشاركين زيارة مختلف الأروقة والفضاءات الثقافية التي تقدم تنوعاً كبيراً من المؤلفات الأدبية والتعليمية والفكرية.

كما مكنت هذه الزيارة من اكتشاف عدد من المبادرات الوطنية التي تشجع على:

📖 القراءة،
🎓 التعلم،
🌱 التنمية الشخصية،
🤝 انخراط الشباب في الحياة الثقافية والتعليمية.

وقد عززت هذه التجربة روح التواصل والتعاون بين أعضاء الجمعية.

🏛️ زيارة رواق البرلمان

من بين أبرز محطات هذه الزيارة، كانت زيارة رواق البرلمان المغربي.

وشارك أعضاء الجمعية في جلسة تفاعلية قدمت:

✔️ مهام البرلمان،
✔️ دور المؤسسة التشريعية،
✔️ كيفية اشتغال اللجان البرلمانية،
✔️ آليات مناقشة القوانين والتصويت عليها.

وقد أثارت النقاشات اهتماماً كبيراً لدى المشاركين، وساهمت في تقريب الشباب أكثر من مفاهيم المواطنة الفاعلة والمشاركة المؤسساتية.

🎁 كما حصل بعض الأعضاء على هدايا تذكارية قدمتها المؤسسة البرلمانية تقديراً لمشاركتهم وتفاعلهم خلال هذا النشاط.

📖 المشاركة في المشروع الوطني للقراءة

كما تميزت الجمعية داخل رواق المشروع الوطني للقراءة.

وشارك المؤطرون والأعضاء في مجموعة من الأنشطة الثقافية والتفاعلية التي ركزت على:

📚 أهمية القراءة،
🎨 الإبداع،
🤝 العمل الجماعي،
💡 روح المبادرة.

وتعكس هذه المشاركة قيم الجمعية القائمة على المعرفة والالتزام وتنمية مهارات الشباب.

🚀 رؤية متجهة نحو المستقبل

من خلال هذه المشاركة، تؤكد جمعية قادة التميز من جديد رغبتها في توفير تجارب غنية لأعضائها تجمع بين الثقافة والتكوين والاكتشاف.

وتساهم هذه المبادرات في تنمية شباب واعٍ ومنفتح على المعرفة ومؤمن بالدور الأساسي للثقافة في التنمية الشخصية والتغيير الإيجابي.
`,

        author: "فريق التواصل ALEOA",
        date: "ماي 2026",
        readTime: "6 دقائق",
        category: "الأنشطة الثقافية",

        tags: [
          "المعرض الدولي للكتاب",
          "الثقافة",
          "الشباب",
          "القراءة",
          "المواطنة",
        ],

        likes: 0,
        comments: 0,

        image: "/images/evnt4.jpeg",

        gallery: ["/images/p13.jpeg", "/images/p16.jpeg"],
      },
    ],
  },
  en: {
    featuredPost: {
      id: 1,

      title:
        "Official Partnership Between Our Association and Atlas Oulmes Badminton Club",

      excerpt:
        "Our association is proud to announce the signing of a strategic partnership with Atlas Oulmes Badminton Club to support sport, youth, and the values of excellence.",

      content: `
🏅 Sport is a fundamental pillar of youth development and strengthening social connections.

With this in mind, our association has formalized a partnership with Atlas Oulmes Badminton Club.

🤝 A Shared Vision

This partnership is based on shared values:

🎯 discipline
🤍 respect
👥 team spirit
🔥 commitment
💪 perseverance

🏸 Atlas Oulmes Badminton Club

The club actively works to:

🌱 train young talents
🏆 promote badminton
🏘️ strengthen the local sporting spirit
✨ pass positive values on to young people

🎯 Partnership Objectives

🏟️ support sports activities
🧒 encourage local youth
🤗 promote sport as a tool for inclusion
🌍 create sustainable community impact

🚀 A Collaboration Looking to the Future

Joint actions will be implemented:

📅 sporting events
🎓 youth support
🤲 community initiatives

🌟 This partnership marks the beginning of a lasting collaboration in support of sport and young people.
`,

      author: "Communication Department",
      date: "February 2025",
      readTime: "6 minutes",
      category: "Sports Partnership",

      tags: ["Partnership", "Sport", "Badminton", "Youth", "Oulmes"],

      likes: 0,
      comments: 0,

      image: "/images/b1.jpg",

      gallery: ["/images/b2.jpg", "/images/b3.jpg"],
    },

    posts: [
      {
        id: 2,

        title:
          "Creating the Association’s Official Website: A Step Toward Digital Transformation",

        excerpt:
          "The association is taking a major step forward with the creation of its official website, a modern platform dedicated to communication, member engagement, and showcasing its actions.",

        content: `
🌍 In an increasingly digital world, having a website is no longer a luxury but a necessity.

With this in mind, our association launched the creation of its official website, a strategic project aimed at strengthening communication and facilitating access to information.

❓ Why Create a Website for the Association?

Before the website was created, communication mainly took place through social media and direct contact.

However, several needs quickly emerged:

📌 centralizing official information,
🎯 clearly presenting the association’s mission and values,
🤝 facilitating the registration of new members,
🌟 showcasing activities, projects, and partnerships,
🔐 providing a dedicated space for members and administrators.

The website became the ideal solution to meet these objectives.

👥 A Platform Designed for Everyone

The website was designed to be:

✅ easy to use, even for people who are less comfortable with digital tools.
📱 accessible on phones, tablets, and computers.
🧭 clear and structured, with intuitive navigation.
⚡ fast and secure, to protect members’ data.

Every page was designed to provide a smooth and professional experience.

🛠️ Useful and Modern Features

The association’s website is more than a simple showcase.

It includes several important features:

📝 online membership form.
🔑 secure member area.
📊 attendance and activity management.
📰 article and news publishing.
🤝 showcasing partners and projects.

These tools make internal work easier and improve external communication.

🚀 A Tool for Development

Thanks to the website, the association is gaining visibility and credibility.

Partners, volunteers, and the public can now:

👀 quickly understand the association’s activities.
📅 follow current events and projects.
📩 get in touch more easily.
👆 join the community in just a few clicks.

Digital technology is therefore becoming a driver of growth and impact.

🔮 A Vision for the Future

The creation of the website marks the beginning of a new stage.

In the future, the platform will continue to evolve with:

✨ new features.
🎮 more interactive content.
🙌 greater member involvement.
🌐 an even stronger digital presence.

This project demonstrates that the association is keeping pace with the times and placing innovation at the heart of its development.
`,

        author: "Association Digital Team",
        date: "January 2026",
        readTime: "8 minutes",
        category: "Digital Transformation",

        tags: ["Website", "Digital", "Association", "Innovation"],

        likes: 36,
        comments: 12,

        image: "./images/siteweb.jpeg",

        gallery: ["./images/siteweb1.jpeg", "./images/siteweb2.jpeg"],
      },

      {
        id: 3,

        title: "Youth and Training: Building the Skills of Tomorrow",

        excerpt:
          "Youth training is at the heart of sustainable development. Through its actions, the association is committed to supporting young people and strengthening their skills to prepare for a better future.",

        content: `
🎓 Youth and Training: Keys to the Future

Young people represent an invaluable resource for every society.

Investing in youth training means giving them the tools they need to build their future and actively contribute to the development of their communities.

📚 Learning to Act Better

Through training and support initiatives, our association is committed to strengthening young people’s skills, both educationally and personally.

These initiatives aim to develop independence, self-confidence, and a sense of responsibility.

👥 Human and Inclusive Support

Training is not limited to acquiring knowledge.

It also relies on listening, exchange, and sharing experiences.

By creating a supportive environment, the association encourages every young person to discover their potential.

🚀 Preparing Tomorrow’s Leaders

By supporting young people today, we are preparing a generation capable of meeting tomorrow’s challenges.

Through training, young people become committed actors, ready to participate actively in social, cultural, and professional life.

✨ Investing in youth training is a sustainable investment in a better future.
`,

        author: "Training & Youth Team",
        date: "October 2025",
        readTime: "6 minutes",
        category: "Youth & Training",

        tags: ["Youth", "Training", "Education", "Future"],

        likes: 24,
        comments: 7,

        image: "/images/blog.jpg",

        gallery: ["/images/blog1.jpg", "/images/blog2.jpg"],
      },

      {
        id: 4,

        title: "An Institutional Partnership Serving Youth and Innovation",

        excerpt:
          "The partnership with the Ministry of Youth, Culture and Communication – Department of Youth marks an important step in strengthening the association’s actions for young people and innovation.",

        content: `
🤝 A Meaningful Partnership

As part of its commitment to youth, our association had the honor of receiving support from the Ministry of Youth, Culture and Communication – Department of Youth.

This institutional partnership is an essential lever for strengthening the impact of our actions and supporting young people in their personal and professional development.

🎯 Shared Objectives

This partnership is based on a shared vision aimed at:

📌 encouraging innovation and creativity among young people,
🎓 supporting training and mentoring initiatives,
🚀 promoting entrepreneurship and civic engagement,
🤝 creating opportunities for exchange and collaboration,
🌍 contributing to sustainable and inclusive development.

The alignment of values between the association and the Ministry makes it possible to build projects with strong social impact.

🏗️ Concrete Actions on the Ground

Thanks to this partnership, several actions can be implemented:

🧪 developing innovation labs,
📚 organizing workshops and training sessions,
👥 supporting young project leaders,
📢 raising awareness and promoting civic initiatives,
🤲 supporting associations and local stakeholders.

These actions aim to provide young people with an environment conducive to learning and personal growth.

🌱 A Lasting Impact for Youth

The Ministry’s institutional support strengthens the association’s credibility and visibility.

It also helps ensure the continuity and quality of projects while reaching a wider audience.

👀 Young people can therefore benefit from:

✔️ better access to resources,
✔️ structured support,
✔️ training and innovation opportunities,
✔️ a stimulating and inclusive environment.

🔮 A Collaboration Looking to the Future

This partnership is part of a long-term dynamic.

The association aims to develop more innovative projects, expand its partner network, and strengthen youth involvement in social and civic life.

This institutional support confirms the shared commitment to placing young people at the heart of development and building a promising future together.
`,

        author: "Partnerships & Development Team",
        date: "November 2025",
        readTime: "7 minutes",
        category: "Institutional Partnerships",

        tags: ["Partnership", "Youth", "Innovation", "Institutional"],

        likes: 0,
        comments: 0,

        image: "/images/minis.jpeg",
      },

      {
        id: 5,

        title:
          "ALEOA’s Participation in the 2026 International Publishing and Book Fair",

        excerpt:
          "The Association of Leaders of Excellence took part in the 2026 International Publishing and Book Fair through a cultural and educational visit that allowed members to discover several educational, institutional, and cultural spaces.",

        content: `
📚 An Enriching Cultural and Educational Experience

As part of its continued openness to cultural and institutional spaces, the Association of Leaders of Excellence (ALEOA) organized a cultural and educational visit to the International Publishing and Book Fair on Thursday, May 7, 2026.

This outing gave members an enriching experience combining discovery, exchange, and learning in a dynamic atmosphere marked by curiosity and a spirit of sharing.

🌍 Discovering Cultural Spaces

Participants had the opportunity to visit different stands and cultural spaces offering a wide variety of literary, educational, and intellectual works.

The visit also provided an opportunity to discover several national initiatives encouraging:

📖 reading,
🎓 learning,
🌱 personal development,
🤝 youth engagement in cultural and educational life.

This experience strengthened the spirit of communication and collaboration among association members.

🏛️ Visit to the Parliament Stand

One of the highlights of the visit was the visit to the Moroccan Parliament stand.

Association members took part in an interactive session presenting:

✔️ the missions of Parliament,
✔️ the role of the legislative institution,
✔️ the functioning of parliamentary committees,
✔️ the mechanisms for debating and voting on laws.

The discussions generated great interest among participants and helped bring young people closer to the concepts of active citizenship and institutional participation.

🎁 Some members also received souvenirs offered by the parliamentary institution in recognition of their participation and interaction during the activity.

📖 Participation in the National Reading Project

The association also took part in the National Reading Project stand.

Supervisors and members participated in several cultural and interactive activities highlighting:

📚 the importance of reading,
🎨 creativity,
🤝 teamwork,
💡 initiative.

This participation reflects the association’s values based on knowledge, commitment, and youth skills development.

🚀 A Vision for the Future

Through this participation, the Association of Leaders of Excellence reaffirms its commitment to providing members with enriching experiences combining culture, training, and discovery.

These initiatives contribute to developing an aware generation that is open to knowledge and convinced of the essential role of culture in personal development and positive change.
`,

        author: "ALEOA Communication Team",
        date: "May 2026",
        readTime: "6 minutes",
        category: "Cultural Activities",

        tags: ["Book Fair", "Culture", "Youth", "Reading", "Citizenship"],

        likes: 0,
        comments: 0,

        image: "/images/evnt4.jpeg",

        gallery: ["/images/p13.jpeg", "/images/p16.jpeg"],
      },
    ],
  },
};

export function getArticles(language = "fr") {
  const lang = language?.startsWith("ar")
    ? "ar"
    : language?.startsWith("en")
      ? "en"
      : "fr";

  return {
    featuredPost: articles[lang].featuredPost,
    blogPosts: articles[lang].posts,
  };
}
